module.exports = function () {
  this.app.$on('loginSubmit', event => {
    // Generate new token without saving to cookie
    let newUserToken = this.session.generateUserToken(false)
    // Call client gateway to login the user
    this.sdk.post('/auth/login', {
      email: event.email,
      password: event.password,
      device: newUserToken,
      deviceType: 'web',
      d2d: 1
    }, res => {
      if (!res.error) {
        res.token = newUserToken
        this.session.useToken(newUserToken) // Only save the token if successful
        this.app.user = res
        this.app.flash = {}
        res.bday = res.dateOfBirth
        res.country = res.userCountry
        this.app.$emit('loginSuccess', res)
      } else {
        // Not successful, no application state changes except for dialogs
        this.app.flash = { type: 'login', message: res.error.message }
        this.app.$emit('loginFailure', res.error.message)
      }
    }, '/1.1')
  })

  this.app.$on('applyLogin', response => {
    this.session.useToken(response.token) // Only save the token if successful
    this.app.user = response
    this.app.flash = {}
    this.app.$emit('loginSuccess', response)
  })

  this.app.$on('setSession', session => {
    this.session.useToken(session)
  })
}



// WEBPACK FOOTER //
// ./src/events/login.js